class FormOptionGroup {
    Id: number;
    Name: string;
    Items: any[];

    constructor(id: number, name: string, items: any[]) {
        this.Id = id;
        this.Name = name;
        this.Items = items;
    }
}

export default FormOptionGroup;